module.exports = __webpack_public_path__ + "img/leftImg.3fb4f33b.png";